// extracted by mini-css-extract-plugin
export default {"editFavourites":"EditFavouriteButton_editFavourites__URwfx","more":"EditFavouriteButton_more__Lkrrf"};